import { create } from 'zustand';
import { api } from './api';

const useBillingStore = create((set, get) => ({
  subscription: null,
  plans: [],
  billingHistory: [],
  loading: false,
  error: null,

  fetchSubscription: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get('/api/billing/subscription');
      set({ subscription: response.data, loading: false });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to fetch subscription',
        loading: false
      });
    }
  },

  fetchPlans: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get('/api/billing/plans');
      set({ plans: response.data, loading: false });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to fetch plans',
        loading: false
      });
    }
  },

  fetchBillingHistory: async (page = 1, limit = 20) => {
    set({ loading: true, error: null });
    try {
      const response = await api.get(`/api/billing/history?page=${page}&limit=${limit}`);
      set({ billingHistory: response.data, loading: false });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to fetch billing history',
        loading: false
      });
    }
  },

  changePlan: async (planId) => {
    set({ loading: true, error: null });
    try {
      const response = await api.post('/api/billing/change-plan', { plan_id: planId });
      set({ subscription: response.data, loading: false });
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to change plan',
        loading: false
      });
      throw error;
    }
  },

  clearError: () => set({ error: null }),
}));

export default useBillingStore;
